import type { MailboxProviderId } from 'fym-shared/src/music24/outreach/mailboxProviders';
import { useTRPCAPI, useTRPCQuery } from '../../../../trpc/trpc';

export interface MailboxAdminMessage {
  variant: 'googleWorkspace' | 'generic';
  subject: string;
  text: string;
}

/** The message for the mail admin of a work mailbox (design outreach-v2 o5, `mailboxes.adminMessage`). */
export function useMailboxAdminMessage(email: string, providerId: MailboxProviderId) {
  const trpcAPI = useTRPCAPI();
  const query = useTRPCQuery(
    trpcAPI.outreach.mailboxes.adminMessage.queryOptions({ email: email.trim(), providerId }, { retry: false })
  );
  return { message: (query.data as MailboxAdminMessage | null | undefined) ?? null, isLoading: query.isLoading };
}
